import { AudioLines, CalendarCog, FileSliders, FolderArchive, ImageDown, ImagePlus, MonitorDot, Video } from "lucide-react";
import { useDispatch } from "react-redux";

const LessonSelectCard =({icon,cardTitle,cardValue,
    onClickBack ,buttonTitle
})=>{
      const dispatch = useDispatch();
         const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }

      
 const Icon=   icon===1?<Video size={32}  color="rgb(86, 82, 131)"/>:icon===2?<AudioLines size={32}  color="rgb(86, 82, 131)"  
        />:icon===3?<FileSliders size={32}  color="rgb(86, 82, 131)"
        />:icon===4?<ImagePlus size={32}  color="rgb(86, 82, 131)"
        />:icon===5?
       <FolderArchive size={32}  color="rgb(86, 82, 131)" />
       :icon===6?<MonitorDot size={32}  color="rgb(86, 82, 131)" />:"";
     
    return(<>
    
<div align="left" className="itemCourseOuter" style={{marginBottom:"40px",height:"140px"}}> 
                
                <div  className="whatToDoNextItemCardInner" ><div style={{background:"rgba(86, 82, 131,0.1)",width:"50px",height:"50px",borderRadius:"50%",
                      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}>{Icon}</div> 
              
                 <h2>{cardTitle}</h2> 
                </div> <div className="set-expiry-card-bottom">
                <div></div>    <button onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} onClick={()=>{ 
                    onClickBack(cardValue)
                  
                   }}  
                 className="CreateBtnItemCard"  type="submit"
                 id="signupBtn"> <span className="" > {buttonTitle}</span> </button> 
                 
                
            </div>
                </div>
    </>)
}
export default LessonSelectCard;

